import { createSelector } from 'reselect';

import { idX } from '../helpers';

const getModals = state => state.modals;

export const modalsSelector = createSelector(getModals, idX);
